import { classNames } from "components/library/utils/classNames";
import React from "react";

const StepNumber = ({ number }: { number: number }) => {
  return (
    <div className="flex h-32 w-32 items-center  justify-center rounded-full border-[3px] border-[#B8F9B8] border-opacity-25 text-green-300">
      {number}
    </div>
  );
};

const steps = [
  {
    title: "Get Programmatic",
    description:
      "Download Programmatic and install it on your local machine. Spin up a new project in seconds.  🚀",
  },
  {
    title: "Write labeling functions",
    description:
      "Easily create sets of approximate functions and smart rules that run through your data quickly adding labels. Wave goodbye to painstaking manual highlighting. 👋",
  },
  {
    title: "Export large clean datasets",
    description:
      "Programmatic then intelligently combines the noisy labels produced by your functions into a large clean dataset that you can start training models on immediately. ✨",
  },
];

export const ProcessStepsSection = () => {
  return (
    <div className="grid-12 mx-auto mb-28 md:mb-140 ">
      {steps.map((step, index) => (
        <div
          key={index}
          className={classNames(
            "col-span-full min-h-[140] justify-between border-t border-gray-800/50 md:col-span-10 md:col-start-2 md:grid-cols-10 "
          )}
        >
          <div className="grid-10 col-span-full my-32 items-start gap-y-16 md:col-span-9 md:gap-y-24">
            <div className="col-span-full flex  items-center gap-20 md:col-span-4">
              <StepNumber number={index + 1} />
              <h2>{step.title}</h2>
            </div>
            <p className="col-span-full text-left md:col-span-5 md:col-start-5 ">
              {step.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
